import React from "react";
import { FEATURES_MOCK } from "./FeaturesMock";

export interface FeatureProps {
  id: string;
  title: string;
  imageSrc: string;
  setProgressPercent?: (value: number) => void;
  setActiveStep?: (value: number) => void;
  backgroundStyle: string;
  hoverBackgroundStyle: string;
  handleCardSelection: (title: string) => void;
  isSelected: boolean;
  attributes?: {
    name: string;
    description: string;
    thumbnail: string;
  };
}

const AnimationCard: React.FC<FeatureProps> = ({
  id,
  attributes,
  handleCardSelection,
  isSelected,
}) => {
 
  const matchedMock = FEATURES_MOCK.find((item) => item.id === Number(id));
  const backgroundStyle = matchedMock?.backgroundStyle || "#ccc";
  const hoverBackgroundStyle = matchedMock?.hoverBackgroundStyle || "#ddd";
  
  const renderHtml = (str: string) => {
    return <div dangerouslySetInnerHTML={{ __html: str }} />;
  };

  return (
    <div
      className='slider-card'
      style={{
        height: 'max-content',
        width: '358px',
        borderRadius: '20px',
        transition: 'border 0.3s ease-in-out',
      }}>
      <div className={`slide-container ${isSelected ? 'selected' : ''}`} onClick={() => handleCardSelection(attributes?.name || '')}>
        <div
          style={{
            backgroundImage: `url(${attributes?.thumbnail})`,
          }}
          className="slide-container-front">
          <div
            style={{
              background: backgroundStyle,
            }}
            className="slide-container-front-title">
            {attributes?.name}
          </div>
        </div>
        <div
          style={{
            backgroundImage: `url(${attributes?.thumbnail})`,
          }}
          className="slide-container-back">
          <div
            style={{
              background: hoverBackgroundStyle,
            }}
            className="slide-container-back-content">
            <span
              style={{
                color: 'white',
                fontSize: '22px',
                fontWeight: 'lighter',
              }}>
              {attributes?.name}
            </span>
            <span>
              <p className="slide-container-option">{renderHtml(attributes?.description!)}</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimationCard;
